import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD5Payload = ({
  eightDInfoId,
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  occurrenceRows = [],
  nonDetectionRows = [],
  uploadedFiles = [],
  isDisabled = false,
  attachmentsToRemove = [],
  occurrenceToRemove = [],
  nonDetectionToRemove = [],
  currentUserEmail = getCurrentUserEmail(),
  d5Id = null,
}) => {
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();
  const nowIso = new Date().toISOString();

  const OccurrenceResult = occurrenceRows.map((row) => ({
    ...(row.id ? { D5OccurrenceId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    RootCause: row.rootCause || '',
    Action: row.action || '',
    Responsible: row.responsible || '',
    TargetDate: toIsoOrNull(row.date),
    Status: row.status || '',
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
  }));

  const NonDetectionDetails = nonDetectionRows.map((row) => ({
    ...(row.id ? { D5NonDetectionId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    RootCause: row.rootCause || '',
    Action: row.action || '',
    Responsible: row.responsible || '',
    TargetDate: toIsoOrNull(row.date),
    Status: row.status || '',
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
  }));

  const Attachments = (uploadedFiles || []).filter(f => !f.isExisting).map((f) => {
    const base64Data = f.preview || '';
    const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
    return {
      EightDInfoId: finalEightDInfoId,
      AttachmentName: f.file?.name || '',
      AttachmentType: f.file?.type || '',
      AttachmentData: attachmentData,
      CreatedBy: currentUserEmail,
      CreatedOn: nowIso,
    };
  });

  return {
    ...(d5Id ? { D5Id: d5Id } : {}),
    EightDInfoId: finalEightDInfoId,
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
    ModifiedBy: currentUserEmail,
    ModifiedOn: nowIso,
    IsDisabled: Boolean(isDisabled),
    OccurrenceResult,
    NonDetectionDetails,
    Attachments,
    OccurrenceToRemove: occurrenceToRemove || [],
    NonDetectionToRemove: nonDetectionToRemove || [],
    AttachmentsToRemove: attachmentsToRemove || [],
  };
};
